import { Router } from '@angular/router';
import * as jspdf from "jspdf";
import autoTable from "jspdf-autotable";

export class Common {

  constructor(public router: Router) { }
  private static y = 0;
  static byteData: ArrayBuffer;
  static file: any;

  public static loadPdf(byteDataArray: any, studno: string): string {
    try {
      this.byteData = byteDataArray;
      this.file = new Blob([this.base64ToArrayBuffer(this.byteData)], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(this.file);
      const anchor = document.createElement('a');
      anchor.download = studno + '.pdf';
      anchor.href = fileURL;
      anchor.click();

      return fileURL;
    } catch (error) {
      alert(error);
    }
  }

  static base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  public static async createPDF(regNo: string, college: string, nameOfStudent: string) {
    const doc = new jspdf.jsPDF("p", "pt");
    doc.setFont("Cambria");
    doc.setFontSize(14);
    // doc.setFont('Cambria', 'normal', 500);
    this.y = 20;

    const myheader = await this.headerContent(doc, regNo, college, nameOfStudent, "PRE-RECRUITMENT PROCESS (PRP)");

    autoTable(doc,{
      head: await this.headerContent(doc, regNo, college, nameOfStudent, "PRE-RECRUITMENT PROCESS (PRP)"),
      theme: "grid",
      showHead: "everyPage",
      body: await this.loadContent(doc),
    });

    this.y = 20;
    doc.addPage();
    doc.setFont("Cambria");
    autoTable(doc,{
      head: await this.headerContent(doc, regNo, college, nameOfStudent, "RECRUITMENT AND RELIEVING POLICIES"),
      showHead: "everyPage",
      body: await this.loadContent1(doc),
    });

    doc.save("COMPLAINCE.pdf");
  }

  private static async headerContent(doc: any, regNo: string, college: string, nameOfStudent: string, headerText: string) : Promise<any>{
    const img = new Image();
    doc.setFontType("bold");
    img.src = 'assets/img/logo1.png'
    doc.addImage(img, 'png', 480, this.y += 10, 95, this.y);
    doc.setFontSize(14);
    doc.text("REGNO", 40, this.y += 60);
    doc.setFontType("normal");
    doc.setFontSize(11);
    doc.text(`: ${regNo}`, 180, this.y);
    doc.setFontType("bold");
    doc.setFontSize(14);
    doc.text("STUDENT NAME", 40, this.y += 20);
    doc.setFontType("normal");
    doc.setFontSize(11);
    doc.text(`: ${nameOfStudent}`, 180, this.y);
    doc.setFontType("bold");
    doc.setFontSize(14);
    doc.text("COLLEGE", 40, this.y += 20);
    doc.setFontType("normal");
    doc.setFontSize(11);
    doc.text(`: ${college}`, 180, this.y);
    doc.setDrawColor("#000")
    doc.line(38, this.y += 15, 550, this.y);
    doc.setFontSize(16);
    doc.setFontType("bold");
    doc.text(headerText, 50, this.y += 40);
    doc.setFontSize(11.5);
  }

  private static async loadContent(pdf: any):Promise<any> {
    let x = 50;
    pdf.setFontType("normal");
    pdf.text("1. An Aptitude test will be conducted based on which the candidates will be shortlisted for Group Discussion (GD).", x, this.y += 32, { align: 'justify', maxWidth: 500 });
    // pdf.text("Discussion (GD).", x+10, this.y+=14);
    pdf.text("2. Based on the performance in the Aptitude Test and GD, candidates will be shortlisted for Pre-Recruitment Process (PRP) – Stage - I.", x, this.y += 32, { align: 'justify', maxWidth: 500 });
    // pdf.text("", x+10, this.y+=14, {align: 'justify', maxWidth: 500});
    pdf.text("3. In PRP – Stage - I, Core JAVA Training class - Duration of Three days", x, this.y += 32, { align: 'justify', maxWidth: 500 });
    pdf.text("\u2022 First day morning first two hours training , Next two hours practical session First day afternoon first two hours training , Next two hours practical session", x += 40, this.y += 14, { align: 'justify', maxWidth: 450 });
    // pdf.text("", x+10, this.y+=14, {align: 'justify', maxWidth: 500});
    pdf.text("\u2022 Second day morning first two hours training , Next two hours practical session will be conducted for all candidates in Core Java (for venue and schedule, you can get in touch with your Placement Officer / In-charge).", x, this.y += 32, { align: 'justify', maxWidth: 450 });
    // pdf.text(" ", x+5, this.y+=14, {align: 'justify', maxWidth: 500});
    pdf.text("4. After completion of Second day morning session, Second half will be given only for practical purposes. Third day morning will conduct test. The short listed candidates will be considered for Pre-Recruitment Process (PRP) – Stage – II.", x -= 40, this.y += 40, { align: 'justify', maxWidth: 500 });
    // pdf.text("", x+5, this.y+=14);
    pdf.text("5. In PRP – Stage -II , SQL Training class - Duration of two days", x, this.y += 42, { align: 'justify', maxWidth: 500 });
    pdf.text("\u2022 First day morning first two hours training, Next two hours practical session First day afternoon first two hours training , Next two hours practical session", x += 40, this.y += 14, { align: 'justify', maxWidth: 450 });
    pdf.text("6. After completion of Second day morning session, Second half will be given only for practical purposes followed by two hours of test in the afternoon. The short listed candidates will be considered for Pre-Recruitment Process (PRP) – Stage – III.", x -= 40, this.y += 30, { align: 'justify', maxWidth: 500 });
    // pdf.text("", x + 10, this.y += 14, {align: 'justify', maxWidth: 600});
    // pdf.text("", x + 10, this.y += 14, {align: 'justify', maxWidth: 600});
    pdf.text("7. The selected candidates will be on PRP – Stage – III –Training, which will be given for a maximum of 10 working days from the date of commencement, at our Chennai Office only.", x, this.y += 45, { align: 'justify', maxWidth: 500 });
    // pdf.text("", x + 10, this.y+=14, {align: 'justify', maxWidth: 600})
    pdf.text("8. On successful and satisfactory completion of the PRP Training, the candidates will be recruited as Trainee Software Engineer based on the Recruitment and Relieving Policies of the Company.", x, this.y += 35, { align: 'justify', maxWidth: 500 });
    // pdf.text("", x + 10, this.y+=14, {align: 'justify', maxWidth: 600})
    pdf.text("9. After completing PRP, if shortlisted, they have to compulsorily execute a Bond for Two Years and Six Months", x, this.y += 32, { align: 'justify', maxWidth: 500 });
    // pdf.text("Months.", x + 10, this.y+=14);
    pdf.text("10. During the PRP Training period @Chennai, accommodation will be provided free of cost and the selected candidates must stay in the company provided accommodation only.", x, this.y += 32, { align: 'justify', maxWidth: 500 });
    // pdf.text("", x + 10, this.y+=14, {align: 'justify', maxWidth: 500});
    pdf.text("11. The candidates should adhere to the rules and regulations of the company in regard to stay in the company provided accommodation.", x, this.y += 32, { align: 'justify', maxWidth: 500 });
    // pdf.text("", x + 14, this.y+=14);
    pdf.text("12. For availing Food, Rs.100/- (Rupees One Hundred Only) will be charged per day. Availing food is not compulsory and the candidates can make their own arrangements for food, if required. Non-Vegetarian food is not allowed inside the campus. Food will be provided 3 times a day on week days and only once on Sundays/Holidays.", x, this.y += 32, { align: 'justify', maxWidth: 500 });
    // pdf.text("", x + 14, this.y+=14);
    // pdf.text("", x + 14, this.y+=14);

  }

  private static async loadContent1(pdf: any) : Promise<any>{

    let clgtype=JSON.parse(JSON.stringify(sessionStorage.getItem("clgtype")));

    pdf.setFontStyle("normal");
    let x = 50;
    pdf.text("1. Candidates Recruited for Training / Employment should sign a Non-Disclosure Agreement (NDA) and execute a Bond for Two Years and Six Months, the First Three months of the Bond being the Initial Training period and the last Three months being the minimum notice period required for an employee to get relieved from the company after working for a minimum period of Two Years", x, this.y += 30, { align: 'justify', maxWidth: 500 });
    // pdf.text("Two Years and Six Months, the First Three months of the Bond being the Initial Training period and the last Three months", x+10, this.y+=14);
    // pdf.text("being the minimum notice period required for an employee to get relieved from the company after working for a", x+10, this.y+=14);
    // pdf.text("minimum period of Two Years", x+10, this.y+=14);
    pdf.text("2. The period of Software Development Training will be for Three months.", x, this.y += 60, { align: 'justify', maxWidth: 500 });

    if(clgtype=='P')
    pdf.text("3. During the period of Training a stipend of Rs.7,500/- or Rs.9,000/- will be paid.", x, this.y += 20, { align: 'justify', maxWidth: 500 });
    else
    pdf.text("3. During the period of Training a stipend of Rs.10,000/- will be paid.", x, this.y += 20, { align: 'justify', maxWidth: 500 });

    pdf.text("4. On successful and satisfactory completion of the Training period, the candidate will be under Probation for the next Twelve Months.", x, this.y += 20, { align: 'justify', maxWidth: 500 });
    // pdf.text("", x+10, this.y+=14);
    
    if(clgtype=='P')
    pdf.text("5. For the candidates in probation, the CTC will be fixed Rs. 1.44 Lakhs or Rs. 1.80 Lakhs per annum. [*]", x, this.y += 27, { align: 'justify', maxWidth: 500 });
    else
    pdf.text("5. For the candidates in probation, the CTC will be fixed Rs. 2.40 Lakhs per annum. [*]", x, this.y += 27, { align: 'justify', maxWidth: 500 });

    pdf.text("6. On successful completion of the Probation, they will be taken into Permanent Role.", x, this.y += 20, { align: 'justify', maxWidth: 500 });
    pdf.text("7. All selected candidates must serve the organization for a MINIMUM PERIOD OF TWO YEARS AND SIX MONTHS (including the 3 months’ initial training and the 3 month’s notice period) for claiming the  Experience certificate, Salary certificate and Relieving Order.", x, this.y += 20, { align: 'justify', maxWidth: 500 });
    // pdf.text("(including the 3 months’ initial training and the 3 month’s notice period) for claiming the  Experience certificate,", x + 10, this.y += 14, {align: 'justify', maxWidth: 500});
    // pdf.text("Salary certificate and Relieving Order.", x + 10, this.y+=14, {align: 'justify', maxWidth: 500});
    pdf.text("8. All candidates who wish to leave the organization must give a minimum notice period of THREE MONTHS.", x, this.y += 44, { align: 'justify', maxWidth: 500 });
    pdf.text("9. Candidates who give LESS THAN THREE MONTHS’ notice will not be given Experience / Salary Certificates and Relieving Letter", x, this.y += 30, { align: 'justify', maxWidth: 500 });
    // pdf.text(" Relieving Letter", x + 10, this.y+=14);
    pdf.text("10. Candidates who does not satisfy the above condition must pay a Minimum of Rs.2,00,000/- (Rupees Two Lakhs Only) + Applicable Taxes to the Company in lieu of completing the remainder period of the Service Agreement. Certificate will NOT be issued for the period of Training/Employment in the organization.", x, this.y += 30, { align: 'justify', maxWidth: 500 });
    // pdf.text("A", x + 10, this.y+=14, {align: 'justify', maxWidth: 500});
    // pdf.text("Certificate will NOT be issued for the period of Training/Employment in the organization.", x + 10, this.y+=14, {align: 'justify', maxWidth: 500});
    pdf.text("11. Candidates will be posted anywhere in India/Abroad during the period of Employment.", x, this.y += 55, { align: 'justify', maxWidth: 500 });
    pdf.text("12. Saturday will be a working day and Sunday will be the Weekly Holiday.", x, this.y += 20, { align: 'justify', maxWidth: 500 });
    pdf.text("13. Bachelor Accommodation will be provided only during the period of Pre-Recruitment process for Boys and Girls separately.", x, this.y += 20, { align: 'justify', maxWidth: 500 });
    // pdf.text(" separately", x + 10, this.y+=14);
    pdf.text("14. For availing Food, Rs.100/- (Rupees One Hundred Only) will be charged per day. Availing food is not compulsory and the candidates can make their own arrangements for food, if required. Non-Vegetarian food is not allowed inside the campus. Food will be provided 3 times a day on week days and only once on Sundays/Holidays.", x, this.y += 32, { align: 'justify', maxWidth: 500 });
    // pdf.text("14. For availing Food, Rs.100/- (Rupees One Hundred Only) will be charged per day. Availing food is not compulsory and", x, this.y+=20, {align: 'justify', maxWidth: 500});
    // pdf.text("the candidates can make their own arrangements for food, if required. Non-Vegetarian food is not allowed inside the ", x + 14, this.y+=14, {align: 'justify', maxWidth: 500});
    // pdf.text("campus. Food will be provided 3 times a day on week days and only once on Sundays/Holidays.", x + 14, this.y+=14, {align: 'justify', maxWidth: 500});
    pdf.text("I have read, understood and agree to the terms and conditions", x, this.y += 70, { align: 'justify', maxWidth: 500 });
    pdf.setFontStyle("bold");
    pdf.text("Signature of the Candidate", x, this.y += 55);
    pdf.text("Signature of the Parent/ Guardian", x + 320, this.y);
  }
}
